<template>
  <div v-for="(itemGroup, index) in navigationItemsGroup" :key="index">
    <div
      v-if="
        itemGroup.items.find((item) =>
          'route' in item ? appStore.isRouteAuthorized(item.route.name) : true
        )
      "
    >
      <div class="space-y-2">
        <div
          v-if="itemGroup?.name"
          :class="sidebar.open ? 'mt-10 mb-4' : 'mt-[72px]'"
        >
          <div
            v-if="itemGroup.name && sidebar.open"
            class="uppercase font-semibold text-slate-500 text-small whitespace-nowrap overflow-hidden"
          >
            {{ itemGroup.name }}
            <q-badge rounded class="ml-2 font-bold" v-if="badge">{{
              badge
            }}</q-badge>
          </div>
        </div>
        <div
          v-for="navigationItem in itemGroup.items"
          :key="navigationItem.name"
        >
          <SidebarNavigationItem
            v-if="
              'route' in navigationItem
                ? appStore.isRouteAuthorized(navigationItem.route.name)
                : true
            "
            :item="navigationItem"
            :type="itemGroup.position"
            :badge="navigationItem?.badge ? navigationItem.badge : undefined"
            class="w-full"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from 'src/core/stores/app';

import { NavigationItemGroup } from 'src/core/types/app';
import { useLocalStorage } from '@vueuse/core';
import SidebarNavigationItem from './SidebarNavigationItem.vue';

defineProps<{
  mobile: boolean;
  navigationItemsGroup: NavigationItemGroup[];
  badge?: string;
}>();

const appStore = useAppStore();
const sidebar = useLocalStorage('sidebar', { open: true });
</script>
